import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { useI18n } from "@/i18n";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const forced = user?.must_change_password;
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/change-password", { current_password: forced ? undefined : cur, new_password: pw });
      await refresh();
      nav("/");
    } catch (err) { setError(apiError(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm tmc-card p-6 fade-up">
        <h1 className="font-head text-xl font-bold text-white">{t("change_password")}</h1>
        {forced && <p className="text-sm text-amber-400 mt-1">{t("first_login_msg")}</p>}
        <form onSubmit={submit} className="space-y-4 mt-5">
          {!forced && (
            <div>
              <label className="text-xs text-muted-foreground font-mono">{t("current_password")}</label>
              <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="current-password-input"
                className="w-full mt-1 bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
            </div>
          )}
          <div>
            <label className="text-xs text-muted-foreground font-mono">{t("new_password")}</label>
            <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} data-testid="new-password-input"
              className="w-full mt-1 bg-input border border-border rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-primary" />
          </div>
          {error && <div className="text-sm text-rose-400" data-testid="change-password-error">{error}</div>}
          <button type="submit" disabled={busy} data-testid="change-password-submit"
            className="w-full bg-primary hover:opacity-90 text-black font-semibold rounded-lg px-4 py-2.5 flex items-center justify-center gap-2 disabled:opacity-60">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("save")}
          </button>
        </form>
      </div>
    </div>
  );
}
